/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The DailyClosingCount model module.
 * @module model/DailyClosingCount
 * @version 1.0.0
 */
export default class DailyClosingCount {
  /**
   * Constructs a new <code>DailyClosingCount</code>.
   * @alias module:model/DailyClosingCount
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>DailyClosingCount</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DailyClosingCount} obj Optional instance to populate.
   * @return {module:model/DailyClosingCount} The populated <code>DailyClosingCount</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DailyClosingCount()

      if (data.hasOwnProperty('saved_count')) {
        obj['saved_count'] = ApiClient.convertToType(data['saved_count'], 'Number')
      }
      if (data.hasOwnProperty('closed_count')) {
        obj['closed_count'] = ApiClient.convertToType(data['closed_count'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {Number} saved_count
   */
  saved_count = undefined
  /**
   * @member {Number} closed_count
   */
  closed_count = undefined
}
